enum OTPAuthAppPaths {
  LoginEmail = '/',
  LoginOTP = '/login',
  NotFound = '/*',
  Reconfigure = '/otp/reconfigure',
}

export default OTPAuthAppPaths;
